// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import { UIKind } from "../../../define/UIKind";
import { backpackUseRuleI } from "../../config/backpackConst";
import NormalGameManager from "../../manager/NormalGameManager";
import backpackOpenBase from "../backpackOpenBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LetterLayer extends backpackOpenBase {

	@property({ type: cc.Label, displayName:'' })
	labelConfirm: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelTitle: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelContent: cc.Label = null;

    private rule: backpackUseRuleI = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    onBackPackOpenPrefab(...arg: any[]) {
        this.bindData(arg[0]);
    }

    //绑定数据
    bindData(useRule:backpackUseRuleI){
        this.rule = useRule;
    }

    start () {
        NormalGameManager._instance.pauseTimer();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.OPENING_MAIL_LAYER);

        let param = this.rule.backUseOrGiveParam;
        this.labelTitle.string = param['title'];
        this.labelContent.string = param['content'];
        this.labelConfirm.string = param['btnname'];
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.OPENING_MAIL_LAYER);
    }

    onClickStart() {
        NormalGameManager._instance.resumeTimer();
        this.node.destroy();
    }

    // update (dt) {}
}
